import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ProfileImageProvider } from '../src/Components/useProfileImage';
// import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const root = ReactDOM.createRoot(document.getElementById('root'));

// const queryClient = new QueryClient();
root.render(
  // <React.StrictMode>
  // <QueryClientProvider client={queryClient}>
    <ProfileImageProvider>
      <App />
    </ProfileImageProvider>
  // </QueryClientProvider>
  // {/* </React.StrictMode> */}
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
